import React, { useEffect } from "react";
import Footer from "../Footer/Footer";
const PrivacyPolicy = () => {
  // Scroll Up
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <div className="container-fluid bg-light py-5">
        <div className="container">
          <h3 className="text-center fw-bold display-5 mb-4">
            Privacy <span className="font-red">Policy</span>
          </h3>

          <div className="mb-4">
            <h4 className="fw-bold">1. Introduction</h4>
            <p className="font-para">
              At <strong className="font-red">SHIV NEXTGEN TECHNOLOGIES PRIVATE LIMITED</strong>, your privacy
              is important to us. This Privacy Policy explains how we collect,
              use, and protect your personal information when you use our
              services, including drone solutions, AI applications, IoT systems,
              robotics, websites, and mobile applications.
            </p>
          </div>

          <div className="mb-4">
            <h4 className="fw-bold">
              2. Information We <span className="font-red">Collect</span>
            </h4>
            <p className="font-para">
              We may collect the following types of information:
            </p>
            <ul className="list-group list-group-flush px-3">
              <li className="list-group-item bg-light border-0 mb-2 rounded shadow-sm">
                <strong className="fs-6 font-red">Personal Information:</strong>
                <br />
                <span className="font-para">
                  Name, email address, phone number, billing information, etc.
                </span>
              </li>
              <li className="list-group-item bg-light border-0 mb-2 rounded shadow-sm">
                <strong className="fs-6 font-red">Usage Data:</strong> <br />
                <span className="font-para">
                  IP address, browser type, device information, game
                  interactions, and other analytics.
                </span>
              </li>
              <li className="list-group-item bg-light border-0 mb-2 rounded shadow-sm">
                <strong className="fs-6 font-red">Cookies and Tracking:</strong>{" "}
                <br />
                <span className="font-para">
                  We use cookies and similar technologies to improve user
                  experience and analyze site traffic.
                </span>
              </li>
            </ul>
          </div>

          <div className="mb-4">
            <h4 className="fw-bold">
              3. How We Use <span className="font-red">Your Information</span>
            </h4>
            <ul className="list-group list-group-flush">
              <li className="list-group-item d-flex align-items-start">
                <i className="bi bi-check-circle-fill font-red me-2 mt-1"></i>
                To provide, maintain, and improve our technology solutions and services
              </li>
              <li className="list-group-item d-flex align-items-start">
                <i className="bi bi-check-circle-fill font-red me-2 mt-1"></i>
                To communicate with users (support, promotions, updates)
              </li>
              <li className="list-group-item d-flex align-items-start">
                <i className="bi bi-check-circle-fill font-red me-2 mt-1"></i>
                To personalize user experience
              </li>
              <li className="list-group-item d-flex align-items-start">
                <i className="bi bi-check-circle-fill font-red me-2 mt-1"></i>
                To analyze user behavior and enhance functionality
              </li>
              <li className="list-group-item d-flex align-items-start">
                <i className="bi bi-check-circle-fill font-red me-2 mt-1"></i>
                To comply with legal obligations
              </li>
            </ul>
          </div>

          <div className="mb-4">
            <h4 className="fw-bold">
              4. Sharing Your <span className="font-red">Information</span>
            </h4>
            <p className="font-para">
              We do not sell your personal data. We may share your information
              only with:
            </p>
            <ul className="list-group list-group-flush">
              <li className="list-group-item d-flex align-items-start">
                <i className="bi bi-check-circle-fill font-red me-2 mt-1"></i>
                Third-party service providers who help us operate our services
              </li>
              <li className="list-group-item d-flex align-items-start">
                <i className="bi bi-check-circle-fill font-red me-2 mt-1"></i>
                Legal authorities when required by law or to protect our rights
              </li>
              <li className="list-group-item d-flex align-items-start">
                <i className="bi bi-check-circle-fill font-red me-2 mt-1"></i>
                Partners or affiliates in the case of business transfers or
                mergers (with notice to users)
              </li>
            </ul>
          </div>

          <div className="mb-4">
            <h4 className="fw-bold">
              5. Data <span className="font-red">Security</span>
            </h4>
            <p className="font-para">
              We implement appropriate technical and organizational security
              measures to protect your personal data from unauthorized access,
              loss, or misuse.
            </p>
          </div>

          {/* <div className="mb-4">
            <h4 className="fw-bold">
              6. Children’s <span className="font-red">Privacy</span>
            </h4>
            <p className="font-para">
              Our services are not intended for children under the age of 13. We
              do not knowingly collect personal data from children. If we
              discover such data has been collected, we will delete it promptly.
            </p>
          </div> */}

          <div className="mb-4">
            <h4 className="fw-bold">
              6. Your <span className="font-red">Rights</span>
            </h4>
            <p className="font-para">
              Depending on your location, you may have rights to:
            </p>
            <ul className="list-group list-group-flush">
              <li className="list-group-item d-flex align-items-start">
                <i className="bi bi-check-circle-fill font-red me-2 mt-1"></i>
                Access, update, or delete your data
              </li>
              <li className="list-group-item d-flex align-items-start">
                <i className="bi bi-check-circle-fill font-red me-2 mt-1"></i>
                Opt out of marketing communications
              </li>
              <li className="list-group-item d-flex align-items-start">
                <i className="bi bi-check-circle-fill font-red me-2 mt-1"></i>
                Withdraw consent at any time
              </li>
            </ul>

            <p className="font-para">
              To exercise these rights, please contact us using the details
              below.
            </p>
          </div>

          <div className="mb-4">
            <h4 className="fw-bold">
              7. Changes to This{" "}
              <span className="font-red">Privacy Policy</span>
            </h4>
            <p className="font-para">
              SHIV NEXTGEN TECHNOLOGIES PRIVATE LIMITED reserves the right to update this policy at any time.
              Any changes will be posted on this page, and continued use of our
              services indicates your acceptance of the updated policy.
            </p>
          </div>

          <div className="mb-4">
            <h4 className="fw-bold">
              8. Contact <span className="font-red">Us</span>
            </h4>
            <p className="font-para">
              If you have questions or concerns about our Privacy Policy,
              contact us at:
            </p>
            <p className="font-para">
              <span className="me-2">📧</span>
              <a href="mailto:info@theshivgames.com" className="text-decoration-none font-red fw-bold">info@theshivgames.com</a>
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default PrivacyPolicy;
